import { Box, Column, Row, Skeleton, SkeletonBox } from "@hightouch/htui";

const PLACEHOLDER_CARDS = [
  "first",
  "second",
  "third",
  "fourth",
  "fifth",
  "sixth",
];

export const CardsSkeleton = () => (
  <Skeleton isLoading>
    <Row gap={3} flexWrap="wrap">
      {PLACEHOLDER_CARDS.map((card) => (
        <Box key={card} width={48}>
          <SkeletonBox
            width="100%"
            borderRadius="md"
            sx={{ aspectRatio: "1 / 1" }}
          />
          <Column gap={1} mt={2}>
            <SkeletonBox height={3.5} width="80%" borderRadius="sm" />
            <SkeletonBox height={3} width="60%" borderRadius="sm" />
            <SkeletonBox height={3} width="50%" borderRadius="sm" />
          </Column>
        </Box>
      ))}
    </Row>
  </Skeleton>
);
